import React from "react";
import { IoChevronBack, IoShieldCheckmarkOutline } from "react-icons/io5";
import { ROLES, ROLE_LABELS, ALL_PERMISSIONS, PERMISSION_LABELS } from "./constants";

export default function WorkspacePermissionsEdit({
  editingMembre,
  selectedPerms,
  saving,
  onTogglePerm,
  onSave,
  onCancel,
  onRoleChange,
}) {
  return (
    <div className="card border-0 mb-4">
      <div className="card-header bg-transparent border-bottom d-flex align-items-center gap-2">
        <button
          className="btn btn-sm btn-outline-secondary me-2"
          onClick={onCancel}
        >
          <IoChevronBack />
        </button>
        <IoShieldCheckmarkOutline size={20} />
        <h5 className="mb-0">
          Permissions de {editingMembre.prenom} {editingMembre.nom}
        </h5>
      </div>
      <div className="card-body p-4">
        <div className="mb-3">
          <label className="form-label">Rôle</label>
          <select
            className="form-select"
            value={editingMembre.role}
            onChange={(e) => {
              const newRole = e.target.value;
              onRoleChange(editingMembre, newRole);
            }}
          >
            {ROLES.map((r) => (
              <option key={r} value={r}>
                {ROLE_LABELS[r]}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label d-block">
            Permissions spécifiques
          </label>
          <small className="text-muted d-block mb-2">
            Cochez les permissions supplémentaires accordées à ce membre.
          </small>
          {ALL_PERMISSIONS.map((perm) => (
            <div key={perm} className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                id={`perm-${perm}`}
                checked={selectedPerms.includes(perm)}
                onChange={() => onTogglePerm(perm)}
              />
              <label
                className="form-check-label"
                htmlFor={`perm-${perm}`}
              >
                {PERMISSION_LABELS[perm] || perm}
              </label>
            </div>
          ))}
        </div>

        <div className="d-flex gap-2">
          <button
            className="btn btn-primary"
            onClick={onSave}
            disabled={saving}
          >
            {saving ? (
              <span className="spinner-border spinner-border-sm me-1" />
            ) : null}
            Enregistrer
          </button>
          <button
            className="btn btn-outline-secondary"
            onClick={onCancel}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
